<footer class="bg-white  dark:bg-gray-900 text-gray-900 dark:text-gray-300 text-center py-3 mt-auto">
  <p>© 2026 PexLens. All rights reserved.</p>
</footer>